import phrApi, { IParamsGetPhr } from '@/apis/phr/api';
import { useQuery, useQueryClient } from '@tanstack/react-query';

const phrService = {
  useGetPhr: ({ uid, filter }: IParamsGetPhr) => {
    return useQuery({
      queryKey: ['getPhr', uid, filter?.type, filter?.tag],
      queryFn: () => {
        return phrApi.get({ uid, filter });
      },
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
    });
  },
  usePreGetPhr: () => {
    const queryClient = useQueryClient();
    return ({ uid, filter }: IParamsGetPhr) => {
      queryClient.prefetchQuery({
        queryKey: ['getPhr', uid, filter?.type, filter?.tag],
        queryFn: () => phrApi.get({ uid, filter }),
      });
    };
  },
};

export default phrService;
